import React from "react"

import Layout from "../components/Layout"

const IndexPage = () => {
  return <Layout></Layout>
}

export default IndexPage
